import { createSlice } from "@reduxjs/toolkit";
import { getActivityGalleryList, saveActivityGallery, deleteActivityGallery } from "../controller/activityGallery.controller";
import { ActivityGallery } from "../types/activityGalleryType";
import { SaveResponse } from "../types/common";

interface ActivityGalleryState {
  loading: boolean;
  list: ActivityGallery[];
  total: { pages: number; data: number };
  response: SaveResponse | null;
  error: string | null;
}

const initialState: ActivityGalleryState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  response: null,
  error: null,
};

const activityGallerySlice = createSlice({
  name: "activityGallery",
  initialState,
  reducers: {
    resetActivityGalleryResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActivityGalleryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getActivityGalleryList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getActivityGalleryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat galeri kegiatan";
      })
      .addCase(saveActivityGallery.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveActivityGallery.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveActivityGallery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan galeri kegiatan";
      })
      .addCase(deleteActivityGallery.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetActivityGalleryResponse } = activityGallerySlice.actions;
export default activityGallerySlice.reducer;
